// src/components/RouteGuards/RequireAccess.jsx
import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from './hoc/AuthContext';

const RequireAccess = ({ children, requiredRoute }) => {
  const { isAuthenticated, authLoading, selectedDomain } = useContext(AuthContext);
  const location = useLocation();

  // Still loading auth state
  if (authLoading) {
    return <div className="flex justify-center items-center h-screen">Loading...</div>;
  }

  // Not logged in → go to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // No domain selected → redirect to dashboard or domain selector
  if (!selectedDomain || !Array.isArray(selectedDomain.accessList)) {
    return <Navigate to="/" replace />;
  }

  // Normalize the route we're checking
  const routeToCheck = requiredRoute.replace(/^\//, ''); // remove leading slash
  // Check if user has access
  const hasAccess = selectedDomain.accessList.some(item => {
    const allowed = item.route_url.trim();

    // Exact match
    if (allowed === routeToCheck) return true;

    // Parent route match (e.g., "cdp/registrations" allows "cdp/registrations/demographics")
    if (routeToCheck.startsWith(allowed + '/') || routeToCheck === allowed) {
      return true;
    }

    return false;
  });

  // No access → redirect to unauthorized or home
  if (!hasAccess) {
    return <Navigate to="/unauthorized" replace />;
  }

  // All good → render the page
  return children;
};

export default RequireAccess;